// src/features/MeterAnalysis/hooks/useMeterData.js
import { useState, useEffect, useMemo } from 'react';
import { getData } from '../../../services/storageService';

// Конфігурація лічильників з реальними назвами
export const METER_CONFIG = {
  'Cont. agua túnel': { 
    key: 'Cont. agua túnel',
    unit: 'm³', 
    type: 'water', 
    color: 'info' 
  },
  'Cont. agua pozo': { 
    key: 'Cont. agua pozo',
    unit: 'm³', 
    type: 'water', 
    color: 'info' 
  },
  'Cont. agua lavadoras': { 
    key: 'Cont. agua lavadoras',
    unit: 'm³', 
    type: 'water', 
    color: 'info' 
  },
  'Cont. agua calderas': { 
    key: 'Cont. agua calderas',
    unit: 'm³', 
    type: 'water', 
    color: 'info' 
  },
  'Cont. propano depósito': { 
    key: 'Cont. propano depósito',
    unit: 'kg', 
    type: 'propane', 
    color: 'warning' 
  },
  'Cont. propano caldera': { 
    key: 'Cont. propano caldera',
    unit: 'kg', 
    type: 'propane', 
    color: 'warning' 
  },
  'Cont. propano cal. saba': { 
    key: 'Cont. propano cal. saba',
    unit: 'kg', 
    type: 'propane', 
    color: 'warning' 
  },
  'Cont. propano cal. medio': { 
    key: 'Cont. propano cal. medio',
    unit: 'kg', 
    type: 'propane', 
    color: 'warning' 
  },
  'Cont. propano cal. hibri': { 
    key: 'Cont. propano cal. hibri',
    unit: 'kg', 
    type: 'propane', 
    color: 'warning' 
  },
  'Cont. propano secadora': { 
    key: 'Cont. propano secadora',
    unit: 'kg', 
    type: 'propane', 
    color: 'warning' 
  }
};

export const useMeterData = (selectedMeter = null) => {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        const allRecords = await getData('lainsa_records');
        console.log('Loaded meter records:', allRecords);
        setRecords(Array.isArray(allRecords) ? allRecords : []);
      } catch (err) {
        console.error('Error loading meter data:', err);
        setError('Failed to load meter data');
        setRecords([]);
      } finally {
        setLoading(false);
      }
    };
    loadData();
  }, []);

  // Обробляємо дані для всіх лічильників
  const allMetersData = useMemo(() => {
    const result = {};
    
    Object.keys(METER_CONFIG).forEach(meterKey => {
      const config = METER_CONFIG[meterKey];
      
      const meterRecords = records
        .filter(record => {
          // Шукаємо дані лічильника в полі cont
          return record.recordType === 'shift_report' && 
                 record.cont && 
                 record.cont[meterKey] !== undefined &&
                 record.cont[meterKey] !== null &&
                 record.cont[meterKey] !== '';
        })
        .map(record => {
          const value = Number(record.cont[meterKey]) || 0;
          
          // Знаходимо попередній запис для розрахунку споживання
          const previousRecord = records
            .filter(r => r.recordType === 'shift_report' && r.cont && r.cont[meterKey])
            .sort((a, b) => new Date(a.fecha) - new Date(b.fecha))
            .find(r => new Date(r.fecha) < new Date(record.fecha));
          
          const previousValue = previousRecord ? Number(previousRecord.cont[meterKey]) || 0 : 0;
          const consumption = value - previousValue;
          
          return {
            date: record.fecha,
            value: value,
            consumption: consumption > 0 ? consumption : 0, // Тільки позитивне споживання
            shift: record.turno,
            operators: record.operators
          };
        })
        .sort((a, b) => new Date(a.date) - new Date(b.date));

      console.log(`Meter ${meterKey} records:`, meterRecords);

      // Розраховуємо статистику
      const consumptions = meterRecords.map(r => r.consumption).filter(c => c > 0);
      const statistics = consumptions.length > 0 ? {
        totalConsumption: consumptions.reduce((a, b) => a + b, 0),
        averageConsumption: consumptions.reduce((a, b) => a + b, 0) / consumptions.length,
        maxConsumption: Math.max(...consumptions),
        minConsumption: Math.min(...consumptions),
        daysWithData: consumptions.length,
        recordsCount: meterRecords.length
      } : {
        totalConsumption: 0, 
        averageConsumption: 0, 
        maxConsumption: 0, 
        minConsumption: 0, 
        daysWithData: 0, 
        recordsCount: 0
      };

      result[meterKey] = {
        data: meterRecords,
        statistics,
        config: config
      };
    });

    return result;
  }, [records]);

  // Дані для обраного лічильника
  const selectedMeterData = selectedMeter ? allMetersData[selectedMeter] : null;

  console.log('Selected meter data:', selectedMeter, selectedMeterData);

  return {
    allMetersData,
    selectedMeterData,
    loading,
    error,
    metersConfig: METER_CONFIG
  };
};


